module.exports = __webpack_public_path__ + "img/logo.f2972a8a.png";